export default __webpack_public_path__ + "static/avatar-leah-53b844dff52d162c9630617c8bb0bb11.png";